import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HighchartsChartModule } from 'highcharts-angular';


import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { FeaturesModule } from './features/features.module';

// Translate
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { HomeComponent } from './components/home/home.component';
import { WhyEgyptComponent } from './components/why-egypt/why-egypt.component';
import { CarouselHomeComponent } from './components/carousel-home/carousel-home.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CenterServicesComponent } from './components/center-services/center-services.component';
import { WelcomeComponentComponent } from './components/welcome-component/welcome-component.component';
import { MainNavbarComponent } from './components/main-navbar/main-navbar.component';
import { SuccessStoryComponent } from './components/success-story/success-story.component';
import { SearchComponent } from './components/search/search.component';
import { KnowMoreComponent } from './components/know-more/know-more.component';
import { CarouselElDepartmentsComponent } from './components/carousel-el-departments/carousel-el-departments.component';
import { OperationsComponent } from './components/operations/operations.component';
import { NewsComponent } from './components/news/news.component';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';


import { MainIndicatorsComponent } from './components/aboutEgypt/main-indicators/main-indicators.component';
import { SuccessStoresComponent } from './components/aboutEgypt/success-stores/success-stores.component';
import { DevelopmentComponent } from './components/aboutEgypt/development/development.component';
import { YouthComponent } from './components/aboutEgypt/youth/youth.component';
import { WhyChoseEgyptComponent } from './components/aboutEgypt/why-chose-egypt/why-chose-egypt.component';
import { FixLeftSectionComponent } from './fix-left-section/fix-left-section.component';
import { MainwhyEgyptComponent } from './components/mainwhy-egypt/mainwhy-egypt.component';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { MediacenterComponent } from './components/mediacenter/mediacenter.component';
import { MedianewsComponent } from './components/medianews/medianews.component';
import { MediaVideosComponent } from './components/media-videos/media-videos.component';
import { MediaactionsComponent } from './components/mediaactions/mediaactions.component';
import { FixMediaComponent } from './components/fix-media/fix-media.component';
import { AllServicesComponent } from './components/all-services/all-services.component';
import { GoaheadComponent } from './components/goahead/goahead.component';
import { HelpComponent } from './components/help/help.component';
import { InvestmentSectorsComponent } from './components/investment-sectors/investment-sectors.component';
import { FixHelpComponent } from './components/fix-help/fix-help.component';
import { EgyptionsComponent } from './components/egyptions/egyptions.component';
import { FixedSectorsComponent } from './components/fixed-sectors/fixed-sectors.component';
import { AgreementsComponent } from './components/agreements/agreements.component';
import { EconomicperformanceComponent } from './components/economicperformance/economicperformance.component';
import { FixedGoOnComponent } from './components/fixed-go-on/fixed-go-on.component';
import { RealStateComponent } from './components/real-state/real-state.component';
import { MiningComponent } from './components/mining/mining.component';
import { ItComponent } from './components/it/it.component';
import { HealthcareComponent } from './components/healthcare/healthcare.component';
import { FinancialComponent } from './components/financial/financial.component';
import { EducationComponent } from './components/education/education.component';
import { PharmaceuticalComponent } from './components/pharmaceutical/pharmaceutical.component';
import { TourismComponent } from './components/tourism/tourism.component';
import { AgricultureComponent } from './components/agriculture/agriculture.component';
import { TextilesComponent } from './components/textiles/textiles.component';
import { OilgasComponent } from './components/oilgas/oilgas.component';
import { FoodprocessingComponent } from './components/foodprocessing/foodprocessing.component';
import { SetElectronicsComponent } from './components/set-electronics/set-electronics.component';
import { InvestmentReportsComponent } from './components/investment-reports/investment-reports.component';
import { FreeZonesComponent } from './components/free-zones/free-zones.component';
import { ComplaintsComponent } from './components/complaints/complaints.component';
import { GoldenPermissionsComponent } from './components/golden-permissions/golden-permissions.component';
import { EvaluationComponent } from './components/evaluation/evaluation.component';
import { SendDocsComponent } from './components/send-docs/send-docs.component';
import { CsrComponent } from './components/csr/csr.component';
import { FinancialCheckComponent } from './components/financial-check/financial-check.component';
import { AgentAccreditationComponent } from './components/agent-accreditation/agent-accreditation.component';
import { InvestmentJournalComponent } from './components/investment-journal/investment-journal.component';
import { InvestmentLicensesComponent } from './components/investment-licenses/investment-licenses.component';
import { NonConfusionComponent } from './components/non-confusion/non-confusion.component';
import { AssociationsComponent } from './components/associations/associations.component';
import { CompanyModificationsComponent } from './components/company-modifications/company-modifications.component';
import { FoundationComponent } from './components/foundation/foundation.component';
import { ServiceSidebarComponent } from './components/service-sidebar/service-sidebar.component';
import { DocsServiceComponent } from './components/docs-service/docs-service.component';
import { CsrServiceComponent } from './components/csr-service/csr-service.component';
import { FinancialServiceComponent } from './components/financial-service/financial-service.component';
import { HandlingPermissionComponent } from './components/handling-permission/handling-permission.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InvestmentSystemsComponent } from './components/investment-systems/investment-systems.component';
import { BusinessRulesComponent } from './components/business-rules/business-rules.component';
import { RegulationsAndRulesComponent } from './components/regulations-and-rules/regulations-and-rules.component';
import { SuggestedSitesComponent } from './components/suggested-sites/suggested-sites.component';
import { InvestorGuideComponent } from './components/investor-guide/investor-guide.component';
import { InvestorsCenterComponent } from './components/investors-center/investors-center.component';
import { InvestorsAgentsComponent } from './components/investors-agents/investors-agents.component';
import { InvestorsDisputeComponent } from './components/investors-dispute/investors-dispute.component';
import { FrequentlyAskedQuestionsComponent } from './components/frequently-asked-questions/frequently-asked-questions.component';
import { SocialResponsibilityComponent } from './components/social-responsibility/social-responsibility.component';
import { CareEgyptianInvestorsComponent } from './components/care-egyptian-investors/care-egyptian-investors.component';
import { EconomicperformanceHelpComponent } from './components/economicperformance-help/economicperformance-help.component';
import { EgyptianCitizenshipComponent } from './components/egyptian-citizenship/egyptian-citizenship.component';
import { FixHowWeCanHelpComponent } from './components/fix-how-we-can-help/fix-how-we-can-help.component';
import { IndoorinvestmentsComponent } from './indoorinvestments/indoorinvestments.component';
import { InvestmentZonesComponent } from './investment-zones/investment-zones.component';
import { NewsDetailsComponent } from './components/news-details/news-details.component';
import { DataStaticComponent } from './data-static/data-static.component';
import { SocialResponsibilityInvestmentComponent } from './social-responsibility-investment/social-responsibility-investment.component';
import { CentralAdministrationResponsibilityComponent } from './central-administration-responsibility/central-administration-responsibility.component';
import { TheExcellenceCompetitionComponent } from './the-excellence-competition/the-excellence-competition.component';
import { EqualOpportunitiesComponent } from './equal-opportunities/equal-opportunities.component';
import { EventsSocialResponsibilitiesComponent } from './events-social-responsibilities/events-social-responsibilities.component';
import { LatestReleasesComponent } from './latest-releases/latest-releases.component';
import { HowwecanhelpcontactusComponent } from './howwecanhelpcontactus/howwecanhelpcontactus.component';
import { RulesInvestmentsAndBusinessComponent } from './rules-investments-and-business/rules-investments-and-business.component';
import { OrganizeRulesComponent } from './organize-rules/organize-rules.component';
import { MoneyRulesComponent } from './money-rules/money-rules.component';
import { CasheService } from './core/services/cashe.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
export function initVersion(_CashService: CasheService) {
  return () => _CashService.checkVersion();
}

// Main Application Module
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    WhyEgyptComponent,
    CarouselHomeComponent,
    CenterServicesComponent,
    WelcomeComponentComponent,
    MainNavbarComponent,
    SuccessStoryComponent,
    SearchComponent,
    KnowMoreComponent,
    CarouselElDepartmentsComponent,
    OperationsComponent,
    NewsComponent,
    MainIndicatorsComponent,
    SuccessStoresComponent,
    DevelopmentComponent,
    YouthComponent,
    WhyChoseEgyptComponent,
    FixLeftSectionComponent,
    MainwhyEgyptComponent,
    UnderConstructionComponent,
    MediacenterComponent,
    MedianewsComponent,
    MediaVideosComponent,
    MediaactionsComponent,
    FixMediaComponent,
    AllServicesComponent,
    GoaheadComponent,
    HelpComponent,
    InvestmentSectorsComponent,
    FixHelpComponent,
    EgyptionsComponent,
    FixedSectorsComponent,
    AgreementsComponent,
    EconomicperformanceComponent,
    FixedGoOnComponent,
    RealStateComponent,
    MiningComponent,
    ItComponent,
    HealthcareComponent,
    FinancialComponent,
    EducationComponent,
    PharmaceuticalComponent,
    TourismComponent,
    AgricultureComponent,
    TextilesComponent,
    OilgasComponent,
    FoodprocessingComponent,
    SetElectronicsComponent,
    InvestmentReportsComponent,
    FreeZonesComponent,
    ComplaintsComponent,
    GoldenPermissionsComponent,
    EvaluationComponent,
    SendDocsComponent,
    CsrComponent,
    FinancialCheckComponent,
    AgentAccreditationComponent,
    InvestmentJournalComponent,
    InvestmentLicensesComponent,
    NonConfusionComponent,
    AssociationsComponent,
    CompanyModificationsComponent,
    FoundationComponent,
    ServiceSidebarComponent,
    DocsServiceComponent,
    CsrServiceComponent,
    FinancialServiceComponent,
    HandlingPermissionComponent,
    InvestmentSystemsComponent,
    BusinessRulesComponent,
    RegulationsAndRulesComponent,
    SuggestedSitesComponent,
    InvestorGuideComponent,
    InvestorsCenterComponent,
    InvestorsAgentsComponent,
    InvestorsDisputeComponent,
    FrequentlyAskedQuestionsComponent,
    SocialResponsibilityComponent,
    CareEgyptianInvestorsComponent,
    EconomicperformanceHelpComponent,
    EgyptianCitizenshipComponent,
    FixHowWeCanHelpComponent,
    IndoorinvestmentsComponent,
    InvestmentZonesComponent,
    NewsDetailsComponent,
    DataStaticComponent,
    SocialResponsibilityInvestmentComponent,
    CentralAdministrationResponsibilityComponent,
    TheExcellenceCompetitionComponent,
    EqualOpportunitiesComponent,
    EventsSocialResponsibilitiesComponent,
    LatestReleasesComponent,
    HowwecanhelpcontactusComponent,
  RulesInvestmentsAndBusinessComponent,
  OrganizeRulesComponent,
  MoneyRulesComponent,
],
imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    LayoutModule,
    FormsModule,
    ReactiveFormsModule,
    SlickCarouselModule,
    HighchartsChartModule,


    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initVersion,
      deps: [CasheService],
      multi: true,
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
